import { render } from "./StackedBarItem.vue?vue&type=template&id=24b92862&scoped=true"
import script from "./StackedBarItem.vue?vue&type=script&lang=js"
export * from "./StackedBarItem.vue?vue&type=script&lang=js"

import "./StackedBarItem.vue?vue&type=style&index=0&id=24b92862&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b92862"]])

export default __exports__